import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysDiff',
  standalone: true,
})
export class DaysDiffPipe implements PipeTransform {
  transform(start: Date | string | number, end: Date | string | number, label: string = 'd'): string {
    if (!start || !end) return '';

    const startDate = new Date(start);
    const endDate = new Date(end);

    const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endMidnight = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    const diffTime = endMidnight.getTime() - startMidnight.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 0 ? `+${diffDays}${label}` : '';
  }
}